import { UrlAnalyticModel } from "@models/MLTC_R3/UrlAnalytic.model";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";



export interface UrlAnalyticSliceState {
  param: UrlAnalyticModel;
}

const initialState: UrlAnalyticSliceState = {
  param: new UrlAnalyticModel(null)
}

const urlAnalyticSlice = createSlice({
  name: 'MLTC-R3-UrlAnalyticSlice',
  initialState,
  reducers: {
    updateUrlParam: (state, action: PayloadAction<UrlAnalyticModel>) => {
      state.param = action.payload;
    }
  },
  extraReducers: {}
})

export const { updateUrlParam } = urlAnalyticSlice.actions;

export default urlAnalyticSlice.reducer;